import { render, staticRenderFns } from "./InitialImportCenter.vue?vue&type=template&id=2674c24d&scoped=true"
import script from "./InitialImportCenter.vue?vue&type=script&lang=js"
export * from "./InitialImportCenter.vue?vue&type=script&lang=js"
import style0 from "./InitialImportCenter.vue?vue&type=style&index=0&id=2674c24d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674c24d",
  null
  
)

export default component.exports